<template>
    <div>
        <Transition v-if="isLoading"
                    name="spinner">
            <div id="cover-spin">
                <span class="loader">
                    <span>{{ $spinnerText }}</span>
                </span>
            </div>
        </Transition>

        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :showModeOpenId="showModeOpenId"
                :viewParams="viewParams"
                :rowButtonAction="handleRowButton"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <OrderForm :formProps="formProps">
                </OrderForm>
            </template>
            <template #search="searchProps">
                <OrderSearch :searchProps="searchProps">
                </OrderSearch>
            </template>
        </v-view>

        <Dialog modal
                scrollable
                v-model:visible="isCalendarOpen"
                :header="calendarHeader"
                :style="{ width: '80vw' }"
                :contentStyle="{ maxHeight: '80vh', overflow: 'auto' }"
                :pt="dialogPt">
            <WorkplanCalendar v-if="isCalendarOpen"
                              :contractorId="selectedContractorId"
                              :initialDate="selectedFromDate" />
        </Dialog>

    </div>
</template>

<script setup>
import { ref } from "vue";
import WorkplanCalendar from './WorkplanCalendar.vue'
import Dialog from 'primevue/dialog'
import OrderForm from './WorkplanForm.vue'
import OrderSearch from './WorkplanSearch.vue'
import { __, getFromUrl } from '@pages/Helper/utils.js';
import { rowButtonAction } from '@pages/Helper/crud_utils.js';

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    viewParams: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])
const showModeOpenId = getFromUrl()
const isLoading = ref(false)
const isCalendarOpen = ref(false)
const selectedContractorId = ref(null)
const selectedFromDate = ref(null)
const calendarHeader = ref('')
const dialogPt = {
    header: { class: 'form-header' },
    content: { class: 'form-body' },
};

//------------------------------------------------------------------------------

const rowButtonFunctions = {
    showCalendar: (data) => {
        selectedContractorId.value = data.contractor_id
        selectedFromDate.value = data.from_date
        calendarHeader.value = `${data.contractor_name} — ${__('Work plan')}`
        isCalendarOpen.value = true
    },
}

//------------------------------------------------------------------------------

const handleRowButton = (arrButton, data, refreshFn) => {
    rowButtonAction(arrButton, data, rowButtonFunctions, refreshFn)
}

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
